import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { collection, query, where, getDocs, updateDoc, doc } from "firebase/firestore";
import { db } from "../../firebase/firebase";

const CampaignSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const markPaymentInFirestore = async () => {
      const auth = getAuth();
      const user = auth.currentUser;

      if (!user) {
        console.error("❌ No user logged in.");
        return;
      }

      try {
        const q = query(collection(db, "campaigns"), where("userId", "==", user.uid), where("paymentStatus", "==", "Unpaid"));
        const snapshot = await getDocs(q);

        if (snapshot.empty) {
          console.log("🟡 No unpaid campaigns to mark as paid.");
        } else {
          snapshot.forEach(async (docSnap) => {
            const campaignRef = doc(db, "campaigns", docSnap.id);
            await updateDoc(campaignRef, { paymentStatus: "Paid" });
            console.log(`✅ Updated campaign ${docSnap.id} as Paid`);
          });
        }
      } catch (error) {
        console.error("🔥 Error updating Firestore:", error);
      }
    };

    markPaymentInFirestore();

    const timeout = setTimeout(() => {
      navigate("/campaigns");
    }, 5000);

    return () => clearTimeout(timeout);
  }, [navigate]);

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>
        <span role="img" aria-label="success">✅</span> Payment Successful!
      </h2>
      <p style={styles.text}>
        Your payment was received. You're ready to create your campaign.
      </p>
      <p style={styles.text}>Redirecting to campaigns...</p>
      <button style={styles.button} onClick={() => navigate("/campaigns")}>
        Go to Campaigns Now
      </button>
    </div>
  );
};

const styles = {
  container: {
    padding: "2rem",
    textAlign: "center",
    maxWidth: "600px",
    margin: "60px auto",
    background: "#f0fff4",
    borderRadius: "12px",
  },
  heading: {
    fontSize: "1.8rem",
    marginBottom: "1rem",
    color: "#2e7d32",
  },
  text: {
    fontSize: "1rem",
    color: "#333",
    marginBottom: "0.8rem",
  },
  button: {
    backgroundColor: "#59c9f5",
    color: "white",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    fontSize: "1rem",
    cursor: "pointer",
    marginTop: "1rem",
  },
};

export default CampaignSuccess;